import React from 'react';
import { TouchableOpacity, View, Text, ScrollView } from 'react-native';
import { Connection, ConnectionOrd } from '../~Utilities/Connection';
import { AppMain, FontInfo } from '../~Utilities/Constants';
import { Data, PosData } from '../~Utilities/Data';
import QB from '../~Screens/QB';
import { PriceType, TransactionType } from '../~Utilities/Rq';
import Utilities from '../~Utilities/Utilities';
import { Entypo } from '@expo/vector-icons';

interface IOBControlProps 
  {
  oData           : Data;    
  qbRef?          : React.RefObject<QB>;
  pos_data?       : PosData;
  confirm_actions : boolean;
  def_width       : number;
  def_page        : number;
  }

/*   ====================================================================   */

interface IOBControlState
  {
  button: number;
  page:number;
  }

/*   ====================================================================   */

export default class OBControl extends React.Component<IOBControlProps>
  {
  private static B_REV_POS     = 1;
  private static B_CAN_ALL     = 2;
  private static B_CAN_FTN     = 3;

  private static B_JOIN_BID    = 4;
  private static B_JOIN_ASK    = 5;
  private static B_JOIN_BIDASK = 6;

  private static B_SELL_BID    = 7;
  private static B_BUY_ASK     = 9;


  /*   -------------------------------------------------------------------   */    

  oTimeOut?   : NodeJS.Timeout;
  state       : IOBControlState = {button:AppMain.IMAGINARY, page:0};

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state         = {button:AppMain.IMAGINARY, page:this.props.def_page};
  this.ResetTimeout  = this.ResetTimeout.bind(this);
  this.Reset         = this.Reset.bind(this);
  this.Refresh       = this.Refresh.bind(this);
  this.DoAction      = this.DoAction.bind(this);
  this.IsButtonOn    = this.IsButtonOn.bind(this);

  this.Rq_PlaceOrder = this.Rq_PlaceOrder.bind(this);
  }

  /*   -------------------------------------------------------------------   */

  private ResetTimeout()
  {
  if (this.oTimeOut)
    {
    clearTimeout(this.oTimeOut);
    this.oTimeOut = undefined;
    }
  }

  /*   -------------------------------------------------------------------   */

  private Reset()
  {
    this.ResetTimeout();
  
    this.oTimeOut = setTimeout(() => 
      {
      clearTimeout(this.oTimeOut);        
      this.oTimeOut = undefined;

      this.setState({button:AppMain.IMAGINARY})
      }, 3000);
  }

  /*   ---------------------------------------------------------------------   */

  Refresh()
  {
  this.ResetTimeout();
  this.setState({button:AppMain.IMAGINARY})
  }

  /*   ---------------------------------------------------------------------   */

  componentDidMount() 
  {
  }

  /*   ---------------------------------------------------------------------   */

  shouldComponentUpdate() 
  {
    return(true);
  }

  /*   ---------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.ResetTimeout();
  }

  /*   -------------------------------------------------------------------   */

  private IsButtonOn(iButton)
  {
  return(this.state.button == iButton || this.props.confirm_actions == false);
  }

  /*   -------------------------------------------------------------------   */

  DoAction(iButton : number)
  {
  if (Connection.IsOrderAvailable() == false)
    {
    if (this.props.qbRef?.current?.oOrderRef)                        
      this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
    else
      alert("Order not available");

    return;
    }

  /*   -------------------------------------------------------------------   */    

  if (!this.props.pos_data)
    {
    alert("Position not available");
    return;
    }

  /*   -------------------------------------------------------------------   */    

  let iQty = this.props.qbRef?.current?.oOrderRef?.state.def_qty;

    /*   -------------------------------------------------------------------   */    

  if (this.IsButtonOn(iButton))
    {
    switch(iButton)
      {
      case OBControl.B_REV_POS:
        ConnectionOrd.oConn?.Rq_ReversePosition(this.props.oData.token,
                                                this.props.pos_data,
                                                "Order Book, Reverse Pos Button" 
                                                );
        break;

      case OBControl.B_CAN_ALL:
        ConnectionOrd.oConn?.Rq_CancelAllOrders(this.props.pos_data,
                                                "Order Book, Cancel All Button");
        break;

      case OBControl.B_CAN_FTN:
        ConnectionOrd.oConn?.Rq_CancelAllOrders(this.props.pos_data,
                                                "Order Book, Cncl All & Fltn Button");
        ConnectionOrd.oConn?.Rq_ExitPosition(this.props.pos_data?.acc_key,
                                             this.props.oData.token, 
                                             "Order Book, Cncl All & Fltn Button");
        break;

      case OBControl.B_JOIN_BID:
        this.Rq_PlaceOrder(this.props.pos_data.acc_key,
                                           this.props.oData.token,
                                           TransactionType.BUY,
                                           iQty,
                                           "Order Book, Join Bid Button",
                                           PriceType.LIMIT,
                                           this.props.oData.bid);
        break;

      case OBControl.B_JOIN_ASK:
        this.Rq_PlaceOrder(this.props.pos_data.acc_key,
                                           this.props.oData.token,
                                           TransactionType.SELL,
                                           iQty,
                                           "Order Book, Join Ask Button",
                                           PriceType.LIMIT,
                                           this.props.oData.ask);
        break;

      case OBControl.B_JOIN_BIDASK:
        if (this.Rq_PlaceOrder(this.props.pos_data.acc_key,
                                           this.props.oData.token,
                                           TransactionType.BUY,
                                           iQty,
                                           "Order Book, Join Bid & Ask Button",
                                           PriceType.LIMIT,
                                           this.props.oData.bid))
          this.Rq_PlaceOrder(this.props.pos_data.acc_key,
                                            this.props.oData.token,
                                            TransactionType.SELL,
                                            iQty,
                                            "Order Book, Join Bid & Ask Button",
                                            PriceType.LIMIT,
                                            this.props.oData.ask);
        break;

      case OBControl.B_BUY_ASK:
        this.Rq_PlaceOrder(this.props.pos_data.acc_key,
                                           this.props.oData.token,
                                           TransactionType.BUY,
                                           iQty,
                                           "Order Book, Buy Ask Button",
                                           PriceType.LIMIT,
                                           this.props.oData.ask);
        break;        

      case OBControl.B_SELL_BID:
        this.Rq_PlaceOrder(this.props.pos_data.acc_key,
                                           this.props.oData.token,
                                           TransactionType.SELL,
                                           iQty,
                                           "Order Book, Sell Bid Button",
                                           PriceType.LIMIT,
                                           this.props.oData.bid);
        break;        

      }

    this.setState({button:AppMain.IMAGINARY});
    }
  else if (this.props.confirm_actions == true)
    {
    this.setState({button:iButton});
    this.Reset();
    }
  }

/*   ---------------------------------------------------------------------   */

public Rq_PlaceOrder(sAccKey    : string | undefined,
                      sToken     : string,
                      iTxn       : number,
                      iQty       : number | undefined,
                      sWindowName: string,
                      iPriceType : number = PriceType.MARKET,
                      dPrice     : number | undefined = undefined)
{
  let z = Utilities.FindItem(ConnectionOrd.oSettings, sToken);

  /*   -------------------------------------------------------------------   */

  if (z != AppMain.IMAGINARY)
    {
    let oDef = ConnectionOrd.oSettings[z].oOrdDefaults;

    if (oDef)
      {
      let dt;
      
      if (oDef.cancel_at_en)
        {
        dt = new Date(Date.now())  

        dt.setHours(oDef.cancel_at_hr);
        dt.setMinutes(oDef.cancel_at_min);
        dt.setSeconds(oDef.cancel_at_sec);
    
        if (Date.now() > dt.valueOf())
          {
          if (this.props.qbRef?.current?.oOrderRef)
            this.props.qbRef?.current?.oOrderRef?.
            ShowNoOrder("Cancel At time is less than the current time",
                        [FontInfo.appStyles.txt_black, {fontSize:FontInfo.iFontSize+2,
                          color:'red', opacity:.9, }] );
          else
            alert("Cancel At time is less than the current time");
      
          return(false);
          }
        }
    
      ConnectionOrd.oConn?.Rq_PlaceOrder(sAccKey,
                                        sToken,
                                        iTxn,
                                        iQty,
                                        sWindowName,
                                        iPriceType,
                                        dPrice,
                                        oDef.cancel_after_en? 
                                        oDef.cancel_after_sec : undefined,
                                        oDef.cancel_at_en? 
                                        Math.trunc(dt.valueOf()/1000) : undefined,
                                        
                                        oDef.bracket_target_en? 
                                        oDef.bracket_target_tks : undefined,
                                        oDef.bracket_stop_en? 
                                        oDef.bracket_stop_tks : undefined,
                                        (oDef.bracket_target_en || 
                                        oDef.bracket_stop_en)? 
                                        oDef.bracket_stop_trl : undefined
                                        );
      return(true);
      }
    }

  ConnectionOrd.oConn?.Rq_PlaceOrder(sAccKey,
                                    sToken,
                                    iTxn,
                                    iQty,
                                    sWindowName,
                                    iPriceType,
                                    dPrice);
  return(true);                                   
  }

  /*   -------------------------------------------------------------------   */

  render() 
  {
  return(
  
  <View style={{alignSelf:'center', flexDirection:'row', }}>

    
    <TouchableOpacity style={{backgroundColor:FontInfo.sButton, minWidth:20,
                              marginVertical:5, marginHorizontal:3, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>
                    {
                      let iPage;

                      if (this.state.page > 0) 
                        iPage = this.state.page - 1;
                      else
                        iPage = 2;

                      ConnectionOrd.SaveSettingsSymbol({token:this.props.oData.token,
                                                        iControlPage:iPage});
                      this.setState({page:iPage});
                    }} >

      <Entypo style={{}} name="chevron-small-left" size={20} color='cornflowerblue' />
    </TouchableOpacity>


    <View style={{alignSelf:'center', flexDirection:'column', }}>
{/* Page 0 */}
    <View style={{alignSelf:'center', flexDirection:'row', 
                  display:this.state.page==0? 'flex' : 'flex'}}>
    {/* Reverse Pos */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_REV_POS)? 
                              FontInfo.sButton : FontInfo.sLightBlue, 
                              marginVertical:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_REV_POS)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_REV_POS)? FontInfo.sLightBlue : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Reverse Pos</Text>

    </TouchableOpacity>



    {/* Cancel All */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_CAN_ALL)? 
                              FontInfo.sButton : 'darkorange', 
                              marginVertical:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_CAN_ALL)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_CAN_ALL)? 'darkorange' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Cancel All</Text>

    </TouchableOpacity>    


    {/* Cncl All & Fltn */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_CAN_FTN)? 
                              FontInfo.sButton : '#ef3038', 
                              marginVertical:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_CAN_FTN)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_CAN_FTN)? '#ef3038' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Cncl All & Fltn</Text>

    </TouchableOpacity>    
    </View>


{/* Page 1 */}
    <View style={{alignSelf:'center', flexDirection:'row', 
                  display:this.state.page==1? 'flex' : 'none'}}>
    {/* Join Bid */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_JOIN_BID)? 
                              FontInfo.sButton : 'dodgerblue', 
                              marginBottom:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_JOIN_BID)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_JOIN_BID)? 'dodgerblue' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Join Bid</Text>

    </TouchableOpacity>



    {/* Join Bid & Ask */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_JOIN_BIDASK)? 
                              FontInfo.sButton : '#a745e3', //'#bc4dff', 
                              marginBottom:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_JOIN_BIDASK)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_JOIN_BIDASK)? '#a745e3' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Join Bid & Ask</Text>

    </TouchableOpacity>    


    {/* Join Ask */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_JOIN_ASK)? 
                              FontInfo.sButton : 'hotpink', 
                              marginBottom:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_JOIN_ASK)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_JOIN_ASK)? 'hotpink' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Join Ask</Text>

    </TouchableOpacity>    
    </View>



{/* Page 2 */}
    <View style={{alignSelf:'center', flexDirection:'row', 
                  display:this.state.page==2? 'flex' : 'none'}}>
    {/* Buy At Ask */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_BUY_ASK)? 
                              FontInfo.sButton : 'dodgerblue', 
                              marginBottom:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_BUY_ASK)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_BUY_ASK)? 'dodgerblue' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Buy At Ask</Text>

    </TouchableOpacity>

    {/* Sell At Bid */}
    <TouchableOpacity style={{backgroundColor:!this.IsButtonOn(OBControl.B_SELL_BID)? 
                              FontInfo.sButton : 'hotpink', 
                              marginBottom:5, marginHorizontal:3, minWidth:55, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{this.DoAction(OBControl.B_SELL_BID)}}>

      <Text style={[FontInfo.appStyles.txt_bold, 
                  {color:!this.IsButtonOn(OBControl.B_SELL_BID)? 'hotpink' : 'white', 
                    paddingVertical:2, paddingHorizontal:5, }]}>Sell At Bid</Text>

    </TouchableOpacity>    
    </View>
    
    </View>    


    <TouchableOpacity style={{backgroundColor:FontInfo.sButton, minWidth:20,
                              marginVertical:5, marginHorizontal:3, borderRadius:10, 
                              alignItems:'center', justifyContent:'center'}}
      onPress={()=>{
                    let iPage;

                    if (this.state.page < 2) 
                      iPage = this.state.page + 1;
                    else
                      iPage = 0;

                    ConnectionOrd.SaveSettingsSymbol({token:this.props.oData.token,
                                                      iControlPage:iPage});
                    this.setState({page:iPage});
                    }} >

      <Entypo style={{}} name="chevron-small-right" size={20} color='cornflowerblue' />
    </TouchableOpacity>


  </View>  
  );
  }
}
